import { DropdownButton } from "react-bootstrap";
import ReactDOM from 'react-dom';
/**
 * <DropdownButtonWithDirection />
 *
 * This is simply a wrapper Component for DropdownButton in order to
 * display the dropdown in different directions according to position of
 * the toggle button on the screen.
 *
 * toggle button location | openeing direction
 * -----------------------+-------------------
 *    far right           |   left
 *    far left            |   right
 *    top                 |   down
 *    bottom              |   up
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './DropdownButton.scss';

class DropdownButtonWithDirection extends React.Component {
  // guideHeight and guideWidth roughly state the dim of an element.
  // They are needed to calculate which direction the Dropdown should
  // open torwards.
  static propTypes = {
    dropdownGuideHeight: PropTypes.number,
    dropdownGuideWidth: PropTypes.number
  }

  constructor(props) {
    super(props);

    this._computeDirection = this._computeDirection.bind(this);

    // default direction for dropdown is right/down
    this.state = {
      vertical: "right",
      horizontal: "down",
    }
  }

  _computeDirection() {
    let thisDom = ReactDOM.findDOMNode(this);
    const { dropdownGuideHeight, dropdownGuideWidth } = this.props;
    if (thisDom && global['--classtop-main-section'] && dropdownGuideWidth && dropdownGuideHeight) {
      const containerDim = global['--classtop-main-section'].getBoundingClientRect();
      const elementDim = thisDom.getBoundingClientRect();

      if (containerDim.height - (elementDim.bottom + dropdownGuideHeight) <= 0) {
        this.setState({
          vertical: "up",
        });
      } else {
        this.setState({
          vertical: "down",
        });
      }

      if (containerDim.width - (elementDim.left + dropdownGuideWidth) <= 0) {
        this.setState({
          horizontal: "right",
        });
      } else {
        this.setState({
          horizontal: "left",
        });
      }
    }
  }

  render() {
    let { vertical, horizontal } = this.state;
    let propsToPass = { ...this.props };

    delete propsToPass.dropdownGuideWidth;
    delete propsToPass.dropdownGuideHeight;

    return <DropdownButton {...propsToPass} onClick={this._computeDirection} className={classnames('expand-to-' + vertical, 'expand-to-' + horizontal)} />
  }
}

export default DropdownButtonWithDirection;



// WEBPACK FOOTER //
// ./src/components/UI/DropdownButton/index.js